module.exports = __webpack_public_path__ + "img/shutterstock-1172580451-490x340.6bf7829f.jpg";